import { useState } from 'react';
import { Card, CardContent, Typography, TextField, Button, CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core';
import { getOTP, validateOTP } from '../../data';


export default function Login(props) {
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            justifyContent: 'center',
            minHeight: 360,
            maxWidth: 420,
            margin: `${theme.spacing(4)}px auto 0`,
        },
        grid: {
            maxWidth: 360,
            alignSelf: 'center',
            flex: 'auto',
            padding: theme.spacing(4),
        },
        textField: {
            width: '100%',
            marginTop: theme.spacing(3),
        },
        button: {
            width: '100%',
            marginTop: theme.spacing(3),
        }
    }));
    const classes = useStyles();
    const [screen, setScreen] = useState('email');
    const [email, setEmail] = useState(undefined);
    const [continueEnabled, setContinueEnabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const clickHandler = async () => {
        if (screen === 'email') {
            setError(undefined);
            setLoading(true);
            setContinueEnabled(false);
            const email = document.getElementById('email').value.trim();
            const data = await getOTP(email);
            setLoading(false);
            if (data.success) {
                setContinueEnabled(true);
                setScreen('otp');
                setEmail(email);
            } else {
                setError(data.error);
            }
        }
        if (screen === 'otp') {
            setError(undefined);
            setLoading(true);
            setContinueEnabled(false);
            const otp = document.getElementById('otp').value.trim();
            const response = await validateOTP(email, otp);
            setLoading(false);
            if (response.success && response.data.isValid) {
                document.cookie = `xUser=${response.data.xUser};max-age=${60*60*24*365*3};path=/;SameSite=Strict`;
                props.setRecognized(true);
            } else {
                setError(response.error);
            }
        }
    };
    const validateEmail = () => {
        const email = document.getElementById('email').value.trim();
        if (email.match('@') !== null && email.match('.com$') !== null) {
            setContinueEnabled(true);
        } else {
            setContinueEnabled(false);
        }
    };
    return (
        <Card className={classes.root}>
            <CardContent className={classes.grid}>
                <Typography variant="h6" component="h6">
                    Sign-in to access your leagues
                </Typography>
                {error !== undefined && <Alert severity="error">{error}</Alert>}
                {screen === 'email' && <TextField id="email" label="Enter email" className={classes.textField}
                    onChange={(e) => validateEmail()} />}
                {screen === 'otp' && <TextField id="otp" label="Enter OTP" className={classes.textField} />}
                <Button variant='contained' color='primary' onClick={clickHandler} className={classes.button}
                    disabled={!continueEnabled}>
                    CONTINUE
                    {loading && <CircularProgress />}
                </Button>
            </CardContent>
        </Card>
    );
}
